import { CHECKOUT_PAGE } from "~/utils/url/staticUrls";
import { type WithTranslation } from "react-i18next";
import dayjs from "dayjs";
import { isNonNull } from "~/common/utils/reducers";
import { useSchaefflerTopBannerList } from "~/features/cms/components/schaefflerTopBanner/SchaefflerTopBannerComponent";
import { useSession } from "~/app/config/useSession";

export const isValidPageForSalesBanner = (url: string) => {
  return !url.endsWith(CHECKOUT_PAGE);
};

export function getRemainingTimeLabel(t: WithTranslation["t"], endDate?: number | string) {
  const end = dayjs(endDate);
  const today = dayjs();

  const days = end.diff(today, "day");

  let label;
  if (!endDate) {
    label = t("feature.salesCampaign.indicator.saleEnd.noEnd");
  } else if (days >= 1) {
    label = t("feature.salesCampaign.indicator.saleEnd.days", { count: days });
  } else {
    label = t("feature.salesCampaign.indicator.saleEnd.today");
  }

  return label;
}

export function useActiveCampaignsNotInSmartEdit() {
  const smartEditBanners = useSchaefflerTopBannerList();

  const activeCampaigns = useSession()?.salesCampaign?.activeSalesCampaigns ?? [];

  const smartEditSalesCampaignCodes = smartEditBanners.map((banner) => banner.campaign?.code).filter(isNonNull);
  const campaignsNotInSmartEdit = activeCampaigns.filter(
    (campaign) => !smartEditSalesCampaignCodes.includes(campaign.code),
  );

  return campaignsNotInSmartEdit;
}
